<template>
    <el-drawer
        title="云音乐艺人id匹配导入"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
            <div class="step-item">
                <div class="step-title">1.请下载并填写匹配文件</div>
                <el-button 
                    type="text" 
                    icon="el-icon-download" 
                    @click="downloadTemplate"
                    :loading="downLoading"
                    class="download-btn">
                    下载匹配文件
                </el-button>
            </div>
            <div class="step-item MT30">
                <div class="step-title">2.请上传文件</div>
                <el-upload 
                    drag 
                    action
                    :http-request="uploadExcel"
                    :auto-upload="false"
                    ref="upload"
                    accept=".xls, .xlsx"
                    :show-file-list="true"
                    :before-upload="beforeUpload"
                    :file-list="fileList"
                    :on-change="onChange"
                    :on-remove="onRemove"
                    :disabled="uploadLoading"
                    class="upload-area">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击选择文件</em></div>
                </el-upload>
            </div>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="success" @click="onSubmit" :loading="btnLoading" :disabled="canSubmit">提交</el-button>
        </div>
    </el-drawer>
</template>

<script>
import {uploadFileTmp} from '@/assets/js/commonApi.js';
export default {
    data() {
        return {
            drawerShow: false,
            btnLoading: false,
            downLoading: false,
            uploadLoading: false,
            canSubmit: true,
            fileList: [],
            filePath: ''
        };
    },
    methods: {
        show() {
            this.drawerShow = true;
        },
        close(){
            this.fileList = [];
            this.filePath = '';
            this.canSubmit = true;
            if(this.$refs.upload){
                this.$refs.upload.clearFiles();
            }
            this.drawerShow = false;
        },
        onSubmit() {
            this.$refs.upload.submit();
        },
        downloadTemplate(){
            this.downLoading = true;
            this.$request({
                url: "/performer/createExport",
                method: "POST",
            })
                .then((res) => {
                    const { state, msg } = res.data;
                    if (state == 1 ) {
                        this.$confirm('下载任务创建成功,可以在下载任务列表查看', '提示', {
                            confirmButtonText: '立即查看',
                            cancelButtonText: '稍后再看',
                            type: 'success',
                            center: true,
                            closeOnClickModal: false
                        }).then(() => {
                            this.$router.push({path:'/workbench/downloadList'})
                        }).catch(() => {})
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.downLoading = false;
                });
        },
        async uploadExcel(req){
            this.btnLoading = true;
            this.uploadLoading = true;
            const formData = new FormData();
            formData.append('file', req.file);

            const uploadRes = await uploadFileTmp(formData).catch(err => {
                this.$message({message: err.message, type: 'error'});
            }).finally(() => {
                this.uploadLoading = false;
            });
            
            if (!uploadRes || uploadRes.data.state != 1) {
                this.btnLoading = false;
                this.$message.error(uploadRes && uploadRes.data.msg || '上传失败');
                return;
            }
            
            this.filePath = uploadRes.data.result.url || uploadRes.data.result.urlFull;

            const res = await this.$request({
                url: '/performer/neteaseIdMatch',
                method: 'post',
                params: { path: this.filePath }
            }).catch(() => {
                return { data: { state: '0', msg: '请求错误' } };
            });
            
            const{state,msg,result} = res.data;
            this.btnLoading = false;
            if (state == 1) {
                this.$message.success('导入成功');
                this.$emit('onUpdate');
                this.close();
            }else{
                this.$message.error(msg || '匹配失败');
                this.canSubmit = false;
                this.$refs.upload.clearFiles();
                this.canSubmit = true;
            }
        },
        onChange(file){
            if( file ){
                this.fileList = [{...file}];
                this.canSubmit = false;
            }else{
                this.canSubmit = true;
            }
        },
        onRemove(){
            this.canSubmit = true;
            this.filePath = '';
        },
        beforeUpload(file){
            const type = this.$utils.getFileType(file.name);
            const isType = type === 'xls' || type === 'xlsx';
            if (!isType) {
                this.$message.error('仅支持xls、xlsx文件格式,请重新选择上传文件!');
            }
            return isType;
        },
    },
};
</script>

<style lang="scss" scoped>
.drawer-content {
    width: 500px;
    padding: 20px;
}
.step-item {
    .step-title {
        font-size: 15px;
        font-weight: 500;
        color: #303133;
        margin-bottom: 15px;
    }
    .download-btn {
        color: #409eff;
        font-size: 14px;
        padding: 0;
    }
}
.upload-area {
    width: 100%;
    ::v-deep .el-upload-dragger, 
    ::v-deep .el-upload{
        width: 100%;
    }
}
.drawer-footer {
    padding: 15px 20px;
    border-top: 1px solid #ebeef5;
    text-align: right;
}
</style>
